import type { Booking } from '@/types/api';

/** The first booking that starts at or after `now` (in-progress ones are past), or null. */
export function nextBooking(list: readonly Booking[], now: Date): Booking | null {
  let next: Booking | null = null;
  for (const b of list) {
    if (new Date(b.startsAt) < now) continue;
    if (!next || b.startsAt < next.startsAt) next = b;
  }
  return next;
}
